export const translations = {
  et: {
    translation: {
      nav: {
        home: "Avaleht",
        services: "Teenused",
        portfolio: "Portfoolio",
        team: "Meeskond",
        catering: "Catering",
        quiz: "Sündmuste test",
        pricing: "Hinnad",
        contact: "Kontakt",
        openMenu: "Ava menüü",
        closeMenu: "Sulge menüü",
      },
      seo: {
        title: "4Sisters Events — Sündmuste Korraldamine Eestis",
        description:
          "Korraldame unustamatuid pulmi, ettevõtte sündmusi, festivale ja eraüritusi. Professionaalne sündmuste korraldamine kogu Eestis. Võta meiega ühendust!",
      },
      hero: {
        title: "Korraldame sinu",
        titleHighlight: "unistuste",
        titleEnd: "sündmuse",
        subtitle:
          "Pulmadest ettevõttete sündmusteni, festivalidest privaatsete pidudeni - meie meeskond viib teie ideed ellu.",
        bookEvent: "Broneeri sündmus",
        contact: "Võta ühendust",
      },
      services: {
        title: "Meie",
        titleHighlight: "teenused",
        subtitle: "",
        weddings: {
          title: "Pulmad",
          description:
            "Unistuste pulma planeerimine A-st Z-ni. Dekoratsioonidest muusikani - teeme sinu erilisest päevast unustamatu kogemuse.",
          features: [
            "Asukohad ja dekoratsioonid",
            "Fotograafid ja videograafid",
            "Muusika ja meelelahutus",
            "Toitlustus ja joogid",
          ],
        },
        corporate: {
          title: "Ettevõtte sündmused",
          description:
            "Ärisündmused, konverentsid ja koolitused. Loome keskkonna, mis toetab sinu äri eesmärke.",
          features: [
            "Konverentsid ja seminarid",
            "Firmapeod ja auhinnasündmused",
            "Meeskonnasündmused",
            "Toote tutvustused",
          ],
        },
        festivals: {
          title: "Festivalid",
          description:
            "Suurte välisündmuste korraldamine - muusikafestivalidest kultuuri­sündmusteni. Seminarid ja töötoad.",
          features: [
            "Muusika ja kultuurifestivalid",
            "Toidufestivalid ja laadad",
            "Spordisündmused",
            "Piletimüük ja turundus",
          ],
        },
        concerts: {
          title: "Kontserdid",
          description:
            "Intiimstest saalikontsertidest suurte staadionikontsertideni. Tagame parima heli ja valguse.",
          features: [
            "Heli- ja valgustehnika",
            "Lava- ja publikuala",
            "Turvalisus ja logistika",
            "Artistide eest hoolitsemine",
          ],
        },
        private: {
          title: "Erasündmused",
          description:
            "Sünnipäevad, juubelid ja muud tähtsad sündmused. Loome õhkkonna, mis sobib täpselt sinu stiiliga.",
          features: [
            "Sünnipäevad ja juubelid",
            "Peresündmused",
            "Temaatilised peod",
            "VIP sündmused",
          ],
        },
        planning: {
          title: "Konsultatsioon",
          description:
            "Täielik projektijuhtimine ja konsultatsioon. Aitame luua sündmuse, mis ületab kõik ootused.",
          features: [
            "Kontseptsiooni arendamine",
            "Eelarve planeerimine",
            "Tarnijate koordineerimine",
            "Päeva juhtimine",
          ],
        },
      },
      quiz: {
        title: "Leia oma",
        titleHighlight: "unistuste sündmus",
        subtitle:
          "Vasta 10 küsimusele ja saa personaalne sündmuste soovitus!",
        progress: "Progress",
        questions: {
          eventType: {
            question: "Milline on sinu sündmus?",
            options: {
              wedding: "Pulm",
              corporate: "Ettevõtte sündmus",
              birthday: "Sünnipäev",
              festival: "Festival/Kontsert",
            },
          },
          guestCount: {
            question: "Kui palju külalisi ootad?",
            options: {
              intimate: "Kuni 30 inimest",
              medium: "30-100 inimest",
              large: "100-300 inimest",
              huge: "Üle 300 inimese",
            },
          },
          budget: {
            question: "Milline on sinu eelarve vahemik?",
            options: {
              budget: "Kuni 5000€",
              midRange: "5000€ - 15000€",
              premium: "15000€ - 30000€",
              luxury: "Üle 30000€",
            },
          },
          atmosphere: {
            question: "Milline atmosfäär sobib sulle?",
            options: {
              elegant: "Elegantne ja klassikaline",
              casual: "Lõbus ja vabalt",
              modern: "Moodne ja innovaatiline",
              rustic: "Rustikalne ja naturaalne",
            },
          },
          timing: {
            question: "Millal soovid sündmust korraldada?",
            options: {
              soon: "Järgmise 3 kuu jooksul",
              planning: "6 kuu jooksul",
              future: "Üle aasta",
              flexible: "Olen paindlik",
            },
          },
          location: {
            question: "Millist asukohta eelistad?",
            options: {
              indoor: "Siseruumides",
              outdoor: "Vaba taeva all",
              both: "Mõlemad variandid",
              flexible: "Olen paindlik",
            },
          },
          entertainment: {
            question: "Millist meelelahutust soovid?",
            options: {
              live: "Elav muusika/bänd",
              dj: "DJ/tantsmuusika",
              background: "Taustamuusika",
              none: "Ei soovi muusikat",
            },
          },
          catering: {
            question: "Millist toitlustuse stiili eelistad?",
            options: {
              formal: "Ametlik õhtusöök",
              buffet: "Rootsi laud",
              cocktail: "Kokteilivastuvõtt",
              casual: "Vaba stiil",
            },
          },
          duration: {
            question: "Kui kaua peaks sündmus kestma?",
            options: {
              short: "2-3 tundi",
              half: "Pool päeva",
              full: "Terve päev",
              multi: "Mitu päeva",
            },
          },
          special: {
            question: "Kas on erinõudeid?",
            options: {
              accessibility: "Ligipääsetavus",
              children: "Lastesõbralik",
              photo: "Fotosessioon",
              none: "Ei ole erinõudeid",
            },
          },
        },
        result: {
          title: "Sinu ideaalne sündmus:",
          subtitle:
            "Sinu vastuste põhjal sobib sulle elegantne ja klassikaline pulm kuni 100 külalisega. Soovitame alustada planeerimist vähemalt 8-12 kuud ette.",
          timeline: "Soovituslik planeerimise aeg: 8-12 kuud enne sündmust",
          cta: "Räägime sinu sündmusest!",
        },
      },
      contact: {
        title: "Alustame",
        titleHighlight: "koos",
        subtitle:
          "Võta ühendust ja räägi meile oma unistuste sündmusest. Broneeri tasuta konsultatsioon!",
        form: {
          title: "Saada meile sõnum",
          firstName: "Eesnimi",
          lastName: "Perekonnanimi",
          email: "E-mail",
          phone: "Telefon",
          eventType: "Sündmuse tüüp",
          message: "Sõnum",
          privacy: "Nõustun privaatsustingimustega",
          submit: "Saada sõnum",
          placeholders: {
            firstName: "Sinu eesnimi",
            lastName: "Sinu perekonnanimi",
            email: "sinu.email@näidis.ee",
            phone: "+372 51 92 3590",
            message:
              "Räägi meile oma sündmusest: kuupäev, külaliste arv, eelistused...",
          },
          eventTypes: {
            select: "Vali sündmuse tüüp",
            wedding: "Pulm",
            corporate: "Ettevõtte sündmus",
            birthday: "Sünnipäev",
            festival: "Festival/Kontsert",
            private: "Erasündmus",
            other: "Muu",
          },
          sending: "Saadame...",
        },
        validation: {
          privacyRequired: "Palun nõustu privaatsustingimustega",
        },
        toast: {
          successTitle: "Sõnum saadetud!",
          successDescription: "Täname! Saime sinu sõnumi kätte.",
          errorTitle: "Viga",
          errorDescription:
            "Sõnumi saatmine ebaõnnestus. Palun proovi uuesti.",
        },
        info: {
          heading: "Võta meiega ühendust",
          phoneTitle: "Telefon",
          phoneHours: "E-R 9:00-18:00",
          emailTitle: "E-mail",
          instagramTitle: "Instagram",
          facebookTitle: "Facebook",
        },
        quickCall: {
          title: "Eelistad helistada?",
          description: "Helista otse ja saa oma küsimusele vastus.",
          button: "Helista",
        },
      },
      portfolio: {
        title: {
          part1: "Meie",
          part2: "portfoolio",
        },
        subtitle: "Tutvu meie klientidele loodud sündmustega",
        photos: "fotot",
        viewGallery: "Vaata galeriid",
        categories: {
          privateEvents: "Erasündmused",
          corporateEvents: "Ettevõtte sündmused",
          weddings: "Pulmad",
          seminars: "Seminarid",
        },
      },
      team: {
        title: "Meie",
        titleHighlight: "meeskond",
        subtitle:
          "Tutvu 4Sisters Events meeskonnaga - kirglike ja kogenud professionaalidega, kes muudavad iga sündmuse eriliseks elamuseks.",
        members: {
          annika: {
            role: "Projektijuht/Partner",
            description:
              "Kogenud projektijuht, kes tagab iga detaili professionaalse teostuse.",
          },
          marju: {
            role: "Projektijuht/Partner",
            description:
              "Projektijuht, kes koordineerib kõiki sündmuse aspekte, viies selle sujuvaks tervikuks.",
          },
          kristin: {
            role: "Projektijuht/Partner",
            description:
              "Loov projektijuht, kes annab igale sündmusele ainulaadse ja personaalse puudutuse.",
          },
        },
      },
      testimonials: {
        title: "Klientide",
        titleHighlight: "tagasiside",
        subtitle:
          "Lugege, mida arvavad meie teenustest need, kes on usaldanud meile oma erilised hetked",
      },
      footer: {
        description:
          "Loome unustamatuid hetki, mis toovad inimestele sära silma. Meie kirg on muuta teie soov eriliseks.",
        quickLinksTitle: "Kiired lingid",
        servicesTitle: "Teenused",
        contactTitle: "Kontakt",
        cateringLink: "4Sisters Catering",
        hours: "E-R 9:00-18:00",
        copyright: "© 2024 4Sisters Events. Kõik õigused kaitstud.",
        privacy: "Privaatsustingimused",
        terms: "Kasutustingimused",
        cookies: "Küpsised",
      },
      lightbox: {
        close: "Sulge galerii",
        previous: "Eelmine pilt",
        next: "Järgmine pilt",
        image: "Pilt {{number}}",
        imageAlt: "{{title}} - pilt {{number}}",
      },
    },
  },
  en: {
    translation: {
      nav: {
        home: "Home",
        services: "Services",
        portfolio: "Portfolio",
        team: "Team",
        catering: "Catering",
        quiz: "Event Quiz",
        pricing: "Pricing",
        contact: "Contact",
        openMenu: "Open menu",
        closeMenu: "Close menu",
      },
      seo: {
        title: "4Sisters Events — Event Planning in Estonia",
        description:
          "We organize unforgettable weddings, corporate events, festivals and private celebrations across Estonia. Get in touch with us!",
      },
      hero: {
        title: "We organize your",
        titleHighlight: "dream",
        titleEnd: "event",
        subtitle:
          "From weddings to corporate events, festivals to private parties - our experienced team brings your ideas to life with perfect precision.",
        bookEvent: "Book Event",
        contact: "Get in Touch",
      },
      services: {
        title: "Our",
        titleHighlight: "Services",
        subtitle: "",
        weddings: {
          title: "Weddings",
          description:
            "Dream wedding planning from A to Z. From decorations to music - we make your special day perfect.",
          features: [
            "Venues and decorations",
            "Photographers and videographers",
            "Music and entertainment",
            "Catering and drinks",
          ],
        },
        corporate: {
          title: "Corporate Events",
          description:
            "Professional business events, conferences and training. We create an environment that supports your business goals.",
          features: [
            "Conferences and seminars",
            "Company parties and award ceremonies",
            "Team events",
            "Product launches",
          ],
        },
        festivals: {
          title: "Festivals",
          description:
            "Large outdoor event organization - from music festivals to cultural events. Experience and professionalism.",
          features: [
            "Music and cultural festivals",
            "Food festivals and fairs",
            "Sports events",
            "Ticket sales and marketing",
          ],
        },
        concerts: {
          title: "Concerts",
          description:
            "From intimate hall concerts to large stadium concerts. We ensure the best sound and lighting.",
          features: [
            "Sound and lighting technology",
            "Stage and audience area",
            "Security and logistics",
            "Artist care",
          ],
        },
        private: {
          title: "Private Events",
          description:
            "Birthdays, anniversaries and other important events. We create an atmosphere that fits your style perfectly.",
          features: [
            "Birthdays and anniversaries",
            "Family events",
            "Themed parties",
            "VIP events",
          ],
        },
        planning: {
          title: "Consultation",
          description:
            "Complete project management and consultation. We help create an event that exceeds all expectations.",
          features: [
            "Concept development",
            "Budget planning",
            "Vendor coordination",
            "Day management",
          ],
        },
      },
      quiz: {
        title: "Find Your",
        titleHighlight: "Dream Event",
        subtitle:
          "Answer 10 questions and get personalized event recommendations!",
        progress: "Progress",
        questions: {
          eventType: {
            question: "What is your event?",
            options: {
              wedding: "Wedding",
              corporate: "Corporate Event",
              birthday: "Birthday",
              festival: "Festival/Concert",
            },
          },
          guestCount: {
            question: "How many guests are you expecting?",
            options: {
              intimate: "Up to 30 people",
              medium: "30-100 people",
              large: "100-300 people",
              huge: "Over 300 people",
            },
          },
          budget: {
            question: "What is your budget range?",
            options: {
              budget: "Up to €5000",
              midRange: "€5000 - €15000",
              premium: "€15000 - €30000",
              luxury: "Over €30000",
            },
          },
          atmosphere: {
            question: "What atmosphere suits you?",
            options: {
              elegant: "Elegant and classic",
              casual: "Fun and relaxed",
              modern: "Modern and innovative",
              rustic: "Rustic and natural",
            },
          },
          timing: {
            question: "When do you want to organize the event?",
            options: {
              soon: "Within the next 3 months",
              planning: "Within 6 months",
              future: "Over a year",
              flexible: "I'm flexible",
            },
          },
          location: {
            question: "What type of venue do you prefer?",
            options: {
              indoor: "Indoor venue",
              outdoor: "Outdoor venue",
              both: "Both options",
              flexible: "I'm flexible",
            },
          },
          entertainment: {
            question: "What type of entertainment do you want?",
            options: {
              live: "Live music/band",
              dj: "DJ/dance music",
              background: "Background music",
              none: "No music needed",
            },
          },
          catering: {
            question: "What catering style do you prefer?",
            options: {
              formal: "Formal dinner",
              buffet: "Buffet style",
              cocktail: "Cocktail reception",
              casual: "Casual style",
            },
          },
          duration: {
            question: "How long should the event last?",
            options: {
              short: "2-3 hours",
              half: "Half day",
              full: "Full day",
              multi: "Multiple days",
            },
          },
          special: {
            question: "Do you have special requirements?",
            options: {
              accessibility: "Accessibility needs",
              children: "Child-friendly",
              photo: "Photo session",
              none: "No special requirements",
            },
          },
        },
        result: {
          title: "Your ideal event:",
          subtitle:
            "Based on your answers, an elegant and classic wedding with up to 100 guests suits you. We recommend starting planning at least 8-12 months in advance.",
          timeline: "Recommended planning time: 8-12 months before the event",
          cta: "Let's talk about your event!",
        },
      },
      contact: {
        title: "Let's Start",
        titleHighlight: "Together",
        subtitle:
          "Get in touch and tell us about your dream event. We'll give you a free consultation!",
        form: {
          title: "Send us a message",
          firstName: "First Name",
          lastName: "Last Name",
          email: "Email",
          phone: "Phone",
          eventType: "Event Type",
          message: "Message",
          privacy: "I agree to the privacy policy",
          submit: "Send Message",
          placeholders: {
            firstName: "Your first name",
            lastName: "Your last name",
            email: "your.email@example.com",
            phone: "+372 51 92 3590",
            message:
              "Tell us about your event: date, number of guests, preferences...",
          },
          eventTypes: {
            select: "Select event type",
            wedding: "Wedding",
            corporate: "Corporate Event",
            birthday: "Birthday",
            festival: "Festival/Concert",
            private: "Private Event",
            other: "Other",
          },
          sending: "Sending...",
        },
        validation: {
          privacyRequired: "Please agree to the privacy policy",
        },
        toast: {
          successTitle: "Message sent!",
          successDescription: "Thank you! We received your message.",
          errorTitle: "Error",
          errorDescription: "Could not send the message. Please try again.",
        },
        info: {
          heading: "Get in touch",
          phoneTitle: "Phone",
          phoneHours: "Mon-Fri 9:00-18:00",
          emailTitle: "Email",
          instagramTitle: "Instagram",
          facebookTitle: "Facebook",
        },
        quickCall: {
          title: "Prefer to call?",
          description: "Call us directly and get an answer to your question.",
          button: "Call",
        },
      },
      portfolio: {
        title: {
          part1: "Our",
          part2: "Portfolio",
        },
        subtitle: "Explore the events we've created for our clients",
        photos: "photos",
        viewGallery: "View Gallery",
        categories: {
          privateEvents: "Private Events",
          corporateEvents: "Corporate Events",
          weddings: "Weddings",
          seminars: "Seminars",
        },
      },
      team: {
        title: "Our",
        titleHighlight: "Team",
        subtitle:
          "Meet the 4Sisters Events team - passionate and experienced professionals who turn every event into a special experience.",
        members: {
          annika: {
            role: "Project Manager/Partner",
            description:
              "Experienced project manager who ensures perfect execution of every detail.",
          },
          marju: {
            role: "Project Manager/Partner",
            description:
              "Project manager who coordinates all aspects of events into a seamless whole.",
          },
          kristin: {
            role: "Project Manager/Partner",
            description:
              "Creative project manager who gives each event a unique and personal touch.",
          },
        },
      },
      testimonials: {
        title: "Client",
        titleHighlight: "feedback",
        subtitle:
          "Read what clients say after trusting us with their special moments",
      },
      footer: {
        description:
          "We create unforgettable moments that bring a sparkle to people's eyes. Our passion is turning your wish into something special.",
        quickLinksTitle: "Quick links",
        servicesTitle: "Services",
        contactTitle: "Contact",
        cateringLink: "4Sisters Catering",
        hours: "Mon-Fri 9:00-18:00",
        copyright: "© 2024 4Sisters Events. All rights reserved.",
        privacy: "Privacy policy",
        terms: "Terms of use",
        cookies: "Cookies",
      },
      lightbox: {
        close: "Close gallery",
        previous: "Previous image",
        next: "Next image",
        image: "Image {{number}}",
        imageAlt: "{{title}} - image {{number}}",
      },
    },
  },
  ru: {
    translation: {
      nav: {
        home: "Главная",
        services: "Услуги",
        portfolio: "Портфолио",
        team: "Команда",
        catering: "Кейтеринг",
        quiz: "Тест мероприятий",
        pricing: "Цены",
        contact: "Контакты",
        openMenu: "Открыть меню",
        closeMenu: "Закрыть меню",
      },
      seo: {
        title: "4Sisters Events — Организация мероприятий в Эстонии",
        description:
          "Мы организуем незабываемые свадьбы, корпоративные события, фестивали и частные праздники по всей Эстонии. Свяжитесь с нами!",
      },
      hero: {
        title: "Организуем мероприятие",
        titleHighlight: "вашей",
        titleEnd: "мечты",
        subtitle:
          "От свадеб до корпоративных мероприятий, от фестивалей до частных вечеринок - наша опытная команда воплощает ваши идеи в жизнь с безупречной точностью.",
        bookEvent: "Забронировать мероприятие",
        contact: "Связаться с нами",
      },
      services: {
        title: "Наши",
        titleHighlight: "Услуги",
        subtitle: "",
        weddings: {
          title: "Свадьбы",
          description:
            "Планирование свадьбы мечты от А до Я. От декораций до музыки - делаем ваш особенный день идеальным.",
          features: [
            "Места проведения и декорации",
            "Фотографы и видеографы",
            "Музыка и развлечения",
            "Кейтеринг и напитки",
          ],
        },
        corporate: {
          title: "Корпоративные мероприятия",
          description:
            "Профессиональные бизнес-мероприятия, конференции и тренинги. Создаем среду, которая поддерживает ваши бизнес-цели.",
          features: [
            "Конференции и семинары",
            "Корпоративы и церемонии награждения",
            "Командные мероприятия",
            "Презентации продуктов",
          ],
        },
        festivals: {
          title: "Фестивали",
          description:
            "Организация крупных мероприятий под открытым небом - от музыкальных фестивалей до культурных событий. Опыт и профессионализм.",
          features: [
            "Музыкальные и культурные фестивали",
            "Фестивали еды и ярмарки",
            "Спортивные события",
            "Продажа билетов и маркетинг",
          ],
        },
        concerts: {
          title: "Концерты",
          description:
            "От камерных концертов в залах до крупных стадионных концертов. Обеспечиваем лучший звук и освещение.",
          features: [
            "Звуковое и световое оборудование",
            "Сцена и зрительская зона",
            "Безопасность и логистика",
            "Забота об артистах",
          ],
        },
        private: {
          title: "Частные мероприятия",
          description:
            "Дни рождения, юбилеи и другие важные события. Создаем атмосферу, которая идеально подходит вашему стилю.",
          features: [
            "Дни рождения и юбилеи",
            "Семейные мероприятия",
            "Тематические вечеринки",
            "VIP мероприятия",
          ],
        },
        planning: {
          title: "Консультация",
          description:
            "Полное управление проектом и консультации. Помогаем создать мероприятие, которое превзойдет все ожидания.",
          features: [
            "Разработка концепции",
            "Планирование бюджета",
            "Координация поставщиков",
            "Управление в день мероприятия",
          ],
        },
      },
      quiz: {
        title: "Найдите",
        titleHighlight: "мероприятие мечты",
        subtitle:
          "Ответьте на 10 вопросов и получите персональные рекомендации!",
        progress: "Прогресс",
        questions: {
          eventType: {
            question: "Какое у вас мероприятие?",
            options: {
              wedding: "Свадьба",
              corporate: "Корпоративное мероприятие",
              birthday: "День рождения",
              festival: "Фестиваль/Концерт",
            },
          },
          guestCount: {
            question: "Сколько гостей вы ожидаете?",
            options: {
              intimate: "До 30 человек",
              medium: "30-100 человек",
              large: "100-300 человек",
              huge: "Более 300 человек",
            },
          },
          budget: {
            question: "Каков ваш бюджет?",
            options: {
              budget: "До €5000",
              midRange: "€5000 - €15000",
              premium: "€15000 - €30000",
              luxury: "Более €30000",
            },
          },
          atmosphere: {
            question: "Какая атмосфера вам подходит?",
            options: {
              elegant: "Элегантная и классическая",
              casual: "Веселая и непринужденная",
              modern: "Современная и инновационная",
              rustic: "Рустикальная и натуральная",
            },
          },
          timing: {
            question: "Когда вы хотите организовать мероприятие?",
            options: {
              soon: "В течение следующих 3 месяцев",
              planning: "В течение 6 месяцев",
              future: "Более чем через год",
              flexible: "Я гибок в планах",
            },
          },
          location: {
            question: "Какое место проведения вы предпочитаете?",
            options: {
              indoor: "Внутри помещения",
              outdoor: "На открытом воздухе",
              both: "Оба варианта",
              flexible: "Я гибок в планах",
            },
          },
          entertainment: {
            question: "Какое развлечение вы хотите?",
            options: {
              live: "Живая музыка/группа",
              dj: "DJ/танцевальная музыка",
              background: "Фоновая музыка",
              none: "Музыка не нужна",
            },
          },
          catering: {
            question: "Какой стиль кейтеринга вы предпочитаете?",
            options: {
              formal: "Официальный ужин",
              buffet: "Буфет",
              cocktail: "Коктейльный прием",
              casual: "Неформальный стиль",
            },
          },
          duration: {
            question: "Сколько должно длиться мероприятие?",
            options: {
              short: "2-3 часа",
              half: "Полдня",
              full: "Целый день",
              multi: "Несколько дней",
            },
          },
          special: {
            question: "У вас есть особые требования?",
            options: {
              accessibility: "Потребности в доступности",
              children: "Для детей",
              photo: "Фотосессия",
              none: "Нет особых требований",
            },
          },
        },
        result: {
          title: "Ваше идеальное мероприятие:",
          subtitle:
            "Основываясь на ваших ответах, вам подходит элегантная и классическая свадьба до 100 гостей. Рекомендуем начинать планирование минимум за 8-12 месяцев.",
          timeline:
            "Рекомендуемое время планирования: 8-12 месяцев до мероприятия",
          cta: "Давайте поговорим о вашем мероприятии!",
        },
      },
      contact: {
        title: "Начнем",
        titleHighlight: "Вместе",
        subtitle:
          "Свяжитесь с нами и расскажите о мероприятии своей мечты. Мы дадим вам бесплатную консультацию!",
        form: {
          title: "Отправить нам сообщение",
          firstName: "Имя",
          lastName: "Фамилия",
          email: "Email",
          phone: "Телефон",
          eventType: "Тип мероприятия",
          message: "Сообщение",
          privacy: "Я согласен с политикой конфиденциальности",
          submit: "Отправить сообщение",
          placeholders: {
            firstName: "Ваше имя",
            lastName: "Ваша фамилия",
            email: "your.email@example.com",
            phone: "+372 51 92 3590",
            message:
              "Расскажите о вашем мероприятии: дата, количество гостей, предпочтения...",
          },
          eventTypes: {
            select: "Выберите тип мероприятия",
            wedding: "Свадьба",
            corporate: "Корпоративное мероприятие",
            birthday: "День рождения",
            festival: "Фестиваль/Концерт",
            private: "Частное мероприятие",
            other: "Другое",
          },
          sending: "Отправляем...",
        },
        validation: {
          privacyRequired: "Пожалуйста, примите политику конфиденциальности",
        },
        toast: {
          successTitle: "Сообщение отправлено!",
          successDescription: "Спасибо! Мы получили ваше сообщение.",
          errorTitle: "Ошибка",
          errorDescription:
            "Не удалось отправить сообщение. Пожалуйста, попробуйте еще раз.",
        },
        info: {
          heading: "Свяжитесь с нами",
          phoneTitle: "Телефон",
          phoneHours: "Пн-Пт 9:00-18:00",
          emailTitle: "Email",
          instagramTitle: "Instagram",
          facebookTitle: "Facebook",
        },
        quickCall: {
          title: "Предпочитаете позвонить?",
          description:
            "Позвоните нам напрямую и получите ответ на свой вопрос.",
          button: "Позвонить",
        },
      },
      portfolio: {
        title: {
          part1: "Наше",
          part2: "портфолио",
        },
        subtitle: "Познакомьтесь с мероприятиями, которые мы создали для наших клиентов",
        photos: "фото",
        viewGallery: "Смотреть галерею",
        categories: {
          privateEvents: "Частные мероприятия",
          corporateEvents: "Корпоративные мероприятия",
          weddings: "Свадьбы",
          seminars: "Семинары",
        },
      },
      team: {
        title: "Наша",
        titleHighlight: "Команда",
        subtitle:
          "Познакомьтесь с командой 4Sisters Events - увлеченными и опытными профессионалами, которые превращают каждое мероприятие в особенный опыт.",
        members: {
          annika: {
            role: "Менеджер проектов/Партнер",
            description:
              "Опытный менеджер проектов, который обеспечивает идеальное выполнение каждой детали.",
          },
          marju: {
            role: "Менеджер проектов/Партнер",
            description:
              "Менеджер проектов, который координирует все аспекты мероприятий в единое целое.",
          },
          kristin: {
            role: "Менеджер проектов/Партнер",
            description:
              "Креативный менеджер проектов, который придает каждому мероприятию уникальный и личный штрих.",
          },
        },
      },
      testimonials: {
        title: "Отзывы",
        titleHighlight: "клиентов",
        subtitle:
          "Читайте, что говорят клиенты, доверившие нам свои особенные моменты",
      },
      footer: {
        description:
          "Мы создаем незабываемые моменты, которые зажигают искру в глазах. Наша страсть - превращать ваше желание в нечто особенное.",
        quickLinksTitle: "Быстрые ссылки",
        servicesTitle: "Услуги",
        contactTitle: "Контакты",
        cateringLink: "4Sisters Catering",
        hours: "Пн-Пт 9:00-18:00",
        copyright: "© 2024 4Sisters Events. Все права защищены.",
        privacy: "Политика конфиденциальности",
        terms: "Условия использования",
        cookies: "Cookies",
      },
      lightbox: {
        close: "Закрыть галерею",
        previous: "Предыдущее изображение",
        next: "Следующее изображение",
        image: "Изображение {{number}}",
        imageAlt: "{{title}} - изображение {{number}}",
      },
    },
  },
};
